import React, { useState, useEffect } from 'react';
import { ScheduledCallback } from "./scheduledCallback/ScheduledCallback";
import Icon from "../images/Icon";
import { trackEvent } from "../../modules/tracking";
import { AnalyticsEvents } from "../../modules/analyticsEvents";
const LiveChatPanel = props => {
    const [minimized, setMinimized] = useState(true);
    useEffect(() => {
        if (!window.myRIFT) {
            window.myRIFT = {};
        }
        window.myRIFT.openLiveChatPanel = open;
    }, []);
    const toggle = () => { if (minimized) {
        trackEvent(AnalyticsEvents.help.livechatPop());
    } if (minimized) {
        setMinimized(false);
    }
    else {
        setMinimized(true);
    } };
    const open = () => {
        setMinimized(false); // if there is a liveChatPanel, show it and close the contact-modal
        document.getElementById('contact-modal')?.classList.remove('modal--visible');
    };
    const renderChat = () => { const { callCentreIsOpen, openingData, callCentreWillOpenToday, todaysDay, stepsContent } = props; if (callCentreIsOpen) {
        return /*#__PURE__*/ React.createElement("div", { className: "live-chat-panel__chat-iframe-wrap" }, !minimized && /*#__PURE__*/ React.createElement("iframe", { className: "live-chat-panel__chat-iframe", src: "https://alive5.com/P2ccjJT" }));
    }
    else {
        return /*#__PURE__*/ React.createElement(ScheduledCallback, { openingData: openingData, callCentreWillOpenToday: callCentreWillOpenToday, todaysDay: todaysDay, stepsContent: stepsContent });
    } };
    return /*#__PURE__*/ React.createElement("div", { id: "liveChatPanel", className: `
      live-chat-panel
      ${minimized ? 'live-chat-panel--panel-minimized' : ''}
      ${props.callCentreIsOpen ? 'live-chat-panel--online' : 'live-chat-panel--offline'}
    ` }, /*#__PURE__*/ React.createElement("header", { className: "live-chat-panel__header" }, /*#__PURE__*/ React.createElement("p", null, "Live Chat"), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("button", { className: "live-chat-panel__minimize", onClick: () => toggle() }, /*#__PURE__*/ React.createElement("span", null), /*#__PURE__*/ React.createElement(Icon, { name: "arrowWhite" })))), /*#__PURE__*/ React.createElement("section", null, renderChat(), /*#__PURE__*/ React.createElement("div", { className: "content-loading" })));
};
export default LiveChatPanel;
